import { render, staticRenderFns } from "./PickingView.vue?vue&type=template&id=66dd72c4&scoped=true&"
import script from "./PickingView.vue?vue&type=script&lang=js&"
export * from "./PickingView.vue?vue&type=script&lang=js&"
import style0 from "./PickingView.vue?vue&type=style&index=0&id=66dd72c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66dd72c4",
  null
  
)

export default component.exports